import { IconButton, Link, Text, Tooltip } from '@radix-ui/themes';
import teamtailorLogo from '../../style/logos/teamtailor.svg';

const TeamtailorButton = ({ job }: { job?: { integration: { teamtailor: { companyId: string; jobId: string } } } }) => {
  if (job && job.integration && job.integration.teamtailor) {
    const integration = {
      ...job.integration.teamtailor,
    };

    const link = `https://app.teamtailor.com/companies/${integration.companyId}/jobs/${integration.jobId}/stages`;
    if (integration.jobId === null) return null;
    if (integration.companyId === null) return null;

    return (
      <Tooltip content={<Text size="3">Link to job in Teamtailor</Text>}>
        <Link href={link} target="_blank">
          <IconButton size="3" color="gray" variant="soft" className="flex items-center justify-center ml-2">
            <img
              src={teamtailorLogo}
              style={{
                height: '20px',
                width: '20px',
              }}
            />
          </IconButton>
        </Link>
      </Tooltip>
    );
  } else return null;
};

export default TeamtailorButton;
